import { ReactNode } from 'react';
import investor, { InvestorIconMap } from './investor.tsx';
import advisor from './advisor.tsx';
import firm from './firm.tsx';
import banker from './banker.tsx';
import owner from './owner.tsx';
import teammember from './teammember.tsx';
import { AppMenuModel } from '@/models/AppViewModel.ts';
import { Role } from '@/models/AccountEnums.ts';

export type NavigationItem = {
  text: string;
  route?: string;
  icon?: ReactNode;
  children?: NavigationItem[];
};

const navigation: { [key: string]: NavigationItem[] } = {
  investor: investor,
  advisor: advisor,
  firm: firm,
  banker: banker,
  owner: owner,
  teammember: teammember,
};

export function convertToNavigationItem(
  appMenuItem: AppMenuModel,
  role: Role,
): NavigationItem {
  const icon = appMenuItem.Icon ?? appMenuItem.Path;

  // Default route behavior prefixes role to provided path.
  // Advisor uses a lowercase `/advisor` prefix (clean `/advisor/*` paths). Only
  // the role prefix is lowercased here — segment canonicalization happens in
  // applyMenuPatches via resolveAdvisorNavRoute, so structural menu patches that
  // match on PascalCase segments (e.g. `/DocumentVault`) keep working.
  const rolePrefix = role === Role.Advisor ? '/advisor' : `/${role}`;
  const resolvedRoute = appMenuItem.Path
    ? `${rolePrefix}${appMenuItem.Path}`
    : undefined;

  return {
    text: appMenuItem.Name ?? 'No Name',
    route: resolvedRoute,
    icon: icon ? InvestorIconMap[icon] : undefined,
    children: appMenuItem.Items?.map((item) =>
      convertToNavigationItem(item, role),
    ),
  };
}

// export interface AppMenuModel {
//   Items?: AppMenuModel[] | undefined;
//   IsParent: boolean;
//   Path?: string | undefined;
//   Icon?: string | undefined;
//   Name?: string | undefined;
//   DefaultGroup?: string | undefined;
//   DefaultView?: string | undefined;
// }

export default navigation;
